export const enum Endpoint {
  contactUs = 'contactUs',
  paymentOptions = 'paymentOptions',
}

const enum Method {
  get = 'get',
  post = 'post',
  delete = 'delete',
}

const mods: { [key: string]: string } = {
  public: 'orlov/public',
};

const ENDPOINTS_CATALOG = {
  paymentOptions: {
    v2: {
      mod: mods.public,
      fun: 'payment_options',
    },
  },
  contactUs: {
    v2: {
      mod: mods.public,
      fun: 'contact_us',
    },
  },
};

export function getEndpoint(endpointName: Endpoint) {
  const endpoint = ENDPOINTS_CATALOG[endpointName];
  if (!endpoint) throw new Error(`Endpoint ${endpointName} not found`);
  return { ...endpoint.v2, method: Method.post, url: '/api/' };
}
